import { RouteProps } from "react-router-dom"
import LoginPage from "../Pages/LoginPage";
import HelpPage from "../Pages/HelpPage";
import CategoryControlPage from "../Pages/CategoryControlPage";
import CategoryPage from "../Pages/CategoryPage";
import CreatePostPage from "../Pages/CreatePostPage";
import PublicationsPage from "../Pages/PublicationsPage";
import PostPage from "../Pages/PostPage";
import ProtectedRoute from "./ProtectedRoute";
import React from "react";
import EditPostPage from "../Pages/EditPostPage";
import AdminPage from "../Pages/AdminPage";
import CreateUser from "../Pages/createUser";
import EditUser from "../Pages/EditUser";
import FakeReg from "../Pages/fakeReg";
import PersonalAccountPage from "../Pages/PersonalAccountPage";


export enum AppRoutes {
    LOGIN_PAGE = 'loginPage',
    HELP_PAGE = 'helpPage',
    CATEGORY_CONTROL_PAGE = 'categoryControlPage',
    CATEGORY_PAGE = 'categoryPage',
    CREATE_EDIT_POST_PAGE = 'createEditPostPage',
    PUBLICATIONS_PAGE = 'publicationsPage',
    POST_PAGE = 'postPage',
    EDIT_POST_PAGE = 'editPostPage',
    ADMIN_PAGE = 'adminPage',
    CREATE_USER_PAGE = 'createUserPage',
    EDIT_USER_PAGE = 'editUserPage',
    FAKE_REG = 'fakeRegPage',
    PERSONAL_ACCOUNT_PAGE = 'personalAccountPage',
}

export const RoutePath: Record<AppRoutes, string> = {
    [AppRoutes.LOGIN_PAGE]: '/',
    [AppRoutes.HELP_PAGE]: '/help',
    [AppRoutes.CATEGORY_CONTROL_PAGE]: '/publicationsControl',
    [AppRoutes.CATEGORY_PAGE]: '/category',
    [AppRoutes.CREATE_EDIT_POST_PAGE]: '/createPost',
    [AppRoutes.PUBLICATIONS_PAGE]: '/publications/:id',
    [AppRoutes.POST_PAGE]: '/post/:id',
    [AppRoutes.EDIT_POST_PAGE]: '/editPost/:id',
    [AppRoutes.ADMIN_PAGE]: '/admin',
    [AppRoutes.CREATE_USER_PAGE]: '/createUser',
    [AppRoutes.EDIT_USER_PAGE]: '/editUser/:id',
    [AppRoutes.FAKE_REG]: '/fakeReg',
    [AppRoutes.PERSONAL_ACCOUNT_PAGE]: '/personalAccount',

}

export interface AdditionsProps {
    name: string
}

export const RouteConfig: Record<AppRoutes, RouteProps & AdditionsProps> = {
    [AppRoutes.LOGIN_PAGE]: {
        path: RoutePath.loginPage,
        element: <LoginPage/>,
        name: 'Авторизацiя'
    },

    [AppRoutes.FAKE_REG]: {
        path: RoutePath.fakeRegPage,
        element: <FakeReg/>,
        name: 'Регист'
    },
    [AppRoutes.HELP_PAGE]: {
        path: RoutePath.helpPage,
        element: <HelpPage/>,
        name: 'Допомога'
    },
    [AppRoutes.CATEGORY_CONTROL_PAGE]: {
        path: RoutePath.categoryControlPage,
        element: <ProtectedRoute element={<CategoryControlPage />} roles={["admin", "subadmin"]} />,
        name: 'Керування публiкацiями'
    },
    [AppRoutes.CREATE_USER_PAGE]: {
        path: RoutePath.createUserPage,
        element: <ProtectedRoute element={<CreateUser />} roles={["admin"]} />,
        name: 'Створення користувача'
    },
    [AppRoutes.EDIT_USER_PAGE]: {
        path: RoutePath.editUserPage,
        element: <ProtectedRoute element={<EditUser />} roles={["admin"]} />,
        name: 'Редагування користувача'
    },

    [AppRoutes.ADMIN_PAGE]: {
        path: RoutePath.adminPage,
        element: <ProtectedRoute element={<AdminPage />} roles={["admin"]} />,
        name: 'Панель адмiнiстратора'
    },
    [AppRoutes.CATEGORY_PAGE]: {
        path: RoutePath.categoryPage,
        element: <ProtectedRoute element={<CategoryPage />} roles={["admin", "subadmin", "user"]} />,
        name: 'Категорії'
    },
    [AppRoutes.CREATE_EDIT_POST_PAGE]: {
        path: RoutePath.createEditPostPage,
        element: <ProtectedRoute element={<CreatePostPage />} roles={["admin", "subadmin"]} />,
        name: 'Створення публiкацiї'
    },
    [AppRoutes.PUBLICATIONS_PAGE]: {
        path: RoutePath.publicationsPage,
        element: <ProtectedRoute element={<PublicationsPage />} roles={["admin", "subadmin", "user"]} />,
        name: ''
    },
    [AppRoutes.POST_PAGE]: {
        path: RoutePath.postPage,
        element: <ProtectedRoute element={<PostPage />} roles={["admin", "subadmin", "user"]} />,
        name: ''
    },
    [AppRoutes.EDIT_POST_PAGE]: {
        path: RoutePath.editPostPage,
        element: <ProtectedRoute element={<EditPostPage />} roles={["admin", "subadmin"]} />,
        name: 'Редагування публiкацii'
    },

    [AppRoutes.PERSONAL_ACCOUNT_PAGE]: {
        path: RoutePath.personalAccountPage,
        element: <ProtectedRoute element={<PersonalAccountPage />} roles={["admin", "subadmin", "user"]} />,
        name: 'Особистий кабiнет'
    },


}